import React, { memo } from 'react';
import { Trans as BaseTrans } from 'react-i18next';

const Trans: typeof BaseTrans = ({ ...props }) => {
  return <BaseTrans {...props} />;
};

export default memo(Trans);
